export const serviceAreas = [
  { id: 'clearwater', name: 'Clearwater', href: '#clearwater' },
  { id: 'palm-harbor', name: 'Palm Harbor', href: '#palm-harbor' },
  { id: 'safety-harbor', name: 'Safety Harbor', href: '#safety-harbor' },
  { id: 'dunedin', name: 'Dunedin', href: '#dunedin' },
];

export const footerServiceAreas = [
  'Clearwater',
  'Palm Harbor',
  'Safety Harbor',
  'Dunedin',
];